<template>
  <v-container>
    <v-row>
      <v-col sm="6" cols="12">
        <v-autocomplete
          v-model="filters.country_code"
          :items="countries"
          item-text="name"
          item-value="code"
          clearable
          label="Country"
        />
      </v-col>
      <v-col sm="6" cols="12">
        <v-select v-model="filters.status" :items="statuses" clearable label="Status" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HTTP from '@/api/dog';
import { FiltersMixin } from '@nielsen-media/ui-toolkit-vue';
import { enumFetch } from '@nielsen-media/ui-toolkit-vue-api';

const defaultFilters = {
  country_code: null,
  status: null,
};

export default {
  name: 'ForceUpdateFilterSheet',
  mixins: [FiltersMixin],
  data: () => ({
    filters: { ...defaultFilters },
    countries: [],
    statuses: [],
  }),
  created() {
    this.enumFetch(HTTP, {
      countries: '/countries?per_page=300',
      statuses: '/applications/enum/statuses',
    });
  },
  methods: {
    enumFetch,
    clearFilters() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = defaultFilters[key];
      });
    },
  },
};
</script>
